"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Type = void 0;
const prelude_1 = require("@packages/prelude");
exports.Type = prelude_1.t.strict({
    type: prelude_1.t.literal('UO'),
    id: prelude_1.t.number,
    name: prelude_1.t.NonEmptyString,
    optional: prelude_1.t.boolean,
    'max-duration': prelude_1.t.number,
    description: prelude_1.t.string
}, 'IAParameterUserAudio');
//# sourceMappingURL=UserAudio.js.map